<template>
  <v-app id="inspire">
    <!-- ナビ -->
    <Navbar :drawerLeft="drawerLeft" @drawerClick="drawerEmitEvent"/>

    <!-- 左メニュー -->
    <LeftDrawer :drawer="drawerLeft"/>

    <!-- メインコンテンツ -->
    <v-main class="contents">
      <RouterView/>
    </v-main>

    <!-- フッター -->
    <Footer/>

    <!-- 共通モーダル -->
    <Modal></Modal>

    <!-- 画面ローダー -->
    <Loader></Loader>
  </v-app>
</template>

<script>
import {mapGetters} from "vuex";
import LeftDrawer from './parts/LeftDrawer.vue'
import Navbar from './parts/Navbar.vue'
import Footer from './parts/Footer.vue'
import Modal from "../utility/Modal";
import Loader from "../utility/Loader";

export default {
  components: {
    Navbar,
    LeftDrawer,
    Footer,
    Modal,
    Loader
  },
  data() {
    return {
      drawerLeft: true,
    }
  },
  computed: {
    ...mapGetters({
      isLogin: 'auth/check'
    })
  },
  methods: {
    drawerEmitEvent(drawer) {
      this.drawerLeft = drawer;
    }
  }
}
</script>
